
import {Component, Prop, Vue, Emit} from 'vue-property-decorator';

@Component
export default class PreviewColumn extends Vue {
  @Prop({required: true}) readonly item!: any;
  @Prop({default: false}) readonly disabled!: boolean;

  @Emit('preview-click')
  handlePreviewClick() {
    return this.item;
  }
}
